(() => {
  if (customElements.get('article-gallery')) {
    return;
  }

  class ArticleGallery extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};

      this.visibleSlides = Number(this.dataset.slides)
      this.space = Number(this.dataset.space)

      this.visibleSlidesMobile = Number(this.dataset.slidesm)
      this.spaceMobile = Number(this.dataset.spacem)

      this.sliderPrev = this.querySelector('.swiper-arrow--prev');
      this.sliderNext = this.querySelector('.swiper-arrow--next');
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        slidesPerView: this.visibleSlidesMobile,
        spaceBetween: this.spaceMobile,
        autoHeight: true,
        navigation: {
          prevEl: this.sliderPrev,
          nextEl: this.sliderNext,
        },
        breakpoints: {
          750: {
            slidesPerView: this.visibleSlides,
            spaceBetween: this.space,
          },
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
    }
  }

  customElements.define('article-gallery', ArticleGallery);
})();
